import { render, staticRenderFns } from "./ResidentialStatusSelect.vue?vue&type=template&id=a32ae7fa"
import script from "./ResidentialStatusSelect.vue?vue&type=script&lang=js"
export * from "./ResidentialStatusSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a32ae7fa')) {
      api.createRecord('a32ae7fa', component.options)
    } else {
      api.reload('a32ae7fa', component.options)
    }
    module.hot.accept("./ResidentialStatusSelect.vue?vue&type=template&id=a32ae7fa", function () {
      api.rerender('a32ae7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/user/ResidentialStatusSelect.vue"
export default component.exports